import posthog from 'posthog-js'
import type { PostHog } from 'posthog-js'

const POSTHOG_API_KEY = import.meta.env.VITE_POSTHOG_API_KEY
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST ?? 'https://us.i.posthog.com'

export const createPosthogClient = (): PostHog | null => {
  if (!POSTHOG_API_KEY) {
    console.warn('PostHog API key not found. Analytics will not be initialized.')
    return null
  }

  posthog.init(POSTHOG_API_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: false,
    capture_pageleave: true,
    enable_heatmaps: false,
    loaded: (client) => {
      if (import.meta.env.VITE_DEBUG) {
        client.debug(true)
        console.log('PostHog loaded in debug mode')
      }
      else {
        client.debug(false)
        console.log('PostHog loaded in production mode')
      }
    },
  })

  return posthog
}

